/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { pushDataLayer } from "utility/ga";

import icon_Twitter from "../designs/images/shareButton/icon_Twitter_400*409.png";

import type { FC } from "react";

export const XShareLargeButtonWithCustomLink: FC<{
  eventId: string;
  link: string;
}> = ({ eventId, link }) => {
  const { t } = useI18n();
  const classes = styles();

  const countClicks = () => {
    pushDataLayer({
      event: "share",
      method: "X",
      content_type: "event",
      item_id: eventId,
      eid: eventId,
    });
  };

  return (
    <div css={classes.root}>
      <button
        type="button"
        onClick={() => {
          window.open(link, "_blank", "width=800,height=600");
          countClicks();
        }}
      >
        <img src={icon_Twitter} alt="X" />
        <p>{t("ticket.tweet")}</p>
      </button>
    </div>
  );
};

const styles = () => {
  return {
    root: css`
      button {
        width: 100%;
        display: flex;
        padding: 10px 0;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border: none;
        border-radius: 4px;
        background-color: #000;
        font-size: 14px;
        @media screen and (min-width: 768px) {
          padding: 13px 0;
          font-size: 15px;
          letter-spacing: 2px;
        }

        cursor: pointer;
        img {
          width: 16px;
          height: auto;
        }
        p {
          font-weight: 700;
          color: #fff;
        }
      }
    `,
  };
};
